export default __webpack_public_path__ + "static/media/write.e2e961c4.png";